import { memo, useState } from "react";
import Demo from "@coworker/apprestructured/src/task-management/demo/pages/ComponentDemoPage/demos/Demo/Demo";
import Name from "@coworker/apprestructured/src/task-management/demo/pages/ComponentDemoPage/demos/Name/Name";
import Highlight from "./Highlight/Highlight";
import CreateTaskSchedule, {
  CreateTaskScheduleChangeEvent,
} from "@coworker/apprestructured/src/task-management/components/ScheduleTask/CreateTaskSchedule/CreateTaskSchedule";
import { FixaListView } from "@coworker/apprestructured/src/shared/wrappers/FixaListView/FixaListView";
import Actions from "./Actions/Actions";
import FixaCheckbox from "@coworker/apprestructured/src/shared/wrappers/FixaCheckbox/FixaCheckbox";
import { Recurrence } from "@coworker/apprestructured/src/task-management/types/Schedule";

function TaskScheduleDemo() {
  const [futureStart, setFutureStart] = useState<string | null>(null);
  const [repeatingStart, setRepeatingStart] = useState<string | null>(null);
  const [end, setEnd] = useState<string | null>(null);
  const [recurrence, setRecurrence] = useState<Recurrence | null>(null);
  const [disabled, setDisabled] = useState(false);

  const handleChange = ({
    futureStart,
    repeatingStart,
    end,
    recurrence,
  }: CreateTaskScheduleChangeEvent) => {
    setFutureStart(futureStart);
    setRepeatingStart(repeatingStart);
    setEnd(end);
    setRecurrence(recurrence);
  };

  return (
    <Demo>
      <Name>TaskSchedule</Name>
      <Highlight>
        <FixaListView id="taskscheduledemo" size="small">
          <CreateTaskSchedule
            disabled={disabled}
            futureStart={futureStart}
            repeatingStart={repeatingStart}
            end={end}
            recurrence={recurrence}
            onChange={handleChange}
          />
        </FixaListView>
      </Highlight>
      <Actions>
        <FixaCheckbox
          label="disabled"
          value="taskscheduledemo-disabled"
          id="taskscheduledemo-disabled"
          checked={disabled}
          onChange={() => setDisabled((prev) => !prev)}
        />
      </Actions>
    </Demo>
  );
}

export default memo(TaskScheduleDemo);
